module.exports = require("qtip");


//////////////////
// WEBPACK FOOTER
// external "qtip"
// module id = 29
// module chunks = 0